// extracted by mini-css-extract-plugin
export default {"promotionBannerBox":"style_promotionBannerBox__qrNEM","promotionBanner":"style_promotionBanner__lnC8B","bannerWinningText":"style_bannerWinningText__AVvvF"};